/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AnswerFormQuestionErrorStatus {
  Ok = 'Ok',
  QuestionNotFound = 'QuestionNotFound',
  IncompatibleAnswerType = 'IncompatibleAnswerType',
  IncompatibleAnswerRange = 'IncompatibleAnswerRange'
}
